// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/react-toolbox/lib/avatar/theme.css
// module id = 680
// module chunks = 0